<template>
  <li
    class="subnav__items"
    ref="subnavItem"
    :style="`margin-top: ${subnavitem_h}px`"
    :class="{ 'is-active-sub' : active }"
  >
    <div class="nav__title -sub">
      <span><slot name="label"></slot></span>
      <router-link :to="path"></router-link>
    </div>

    <slot v-if="hasSubnav" name="subnav"></slot>
  </li>
</template>

<script>
//= mixins
import { ready } from '@/assets/js/mixins/base/Ready'

export default {
  name: 'sub-nav-item',

  props: {
    path: [String],
    defaultPath: [String]
  },

  mixins: [ ready ],

  data () {
    return {
      subnavitem_h: null,
      active: false,
      group: null,
      multipleRoutes: false,

      dPath: null,
      currentPath: null
    }
  },

  watch: {
    async '$route' ($router) {
      this.validateRoute()
    }
  },

  computed: {
    hasSubnav () {
      return this.$slots['subnav']
    }
  },

  inject: {
    handleNav: {}
  },

  mounted () {
    let subnavItem = this.$refs.subnavItem

    if (this.$refs.subnavItem) {
      this.subnavitem_h = Math.abs(parseInt(subnavItem.offsetHeight)) * -1
    }

    this.$nextTick(() => {
      let parent = this.$parent.$parent
      this.group = parent.group


      if (this.$parent.$parent.$el.classList.contains('subnav__items')) {
        this.group = this.$parent.$parent.$parent.$parent.group
      }

      this.validateRoute()
    })
  },

  methods: {
    validateRoute () {
      this.$parent.$parent.active = false
      this.active = false

      this.$nextTick(() => {
        this.currentPath = this.$route.path
        // this.dPath = this.defaultPath || this.path
        //
        // if (this.currentPath.indexOf(this.dPath) > -1) {
        //   if (this.group === this.$parent.$parent.group) {
        //     this.active = true
        //     this.$parent.$parent.active = true
        //   }
        // }
      })
    }
  }
}
</script>
